export default __webpack_public_path__ + "static/media/personnel_color.4b521664.svg";